module.exports = {
	"container": "findify-components--color-facet__container",
	"item": "findify-components--color-facet__item",
	"active": "findify-components--color-facet__active",
	"ball": "findify-components--color-facet__ball",
	"check": "findify-components--color-facet__check"
};